import { Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import moment from "moment";
import { useEffect, useState } from "react";
import TableTooltip from "../../../Common/TableTooltip";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DriverRegistration from "../DriverRegistration";
import { getIndividual } from "../../../../actions/driverAppApprovalActions";
import TablePaginationActions from "../../../Common/TablePagination";
import { getUserPreference } from "../../../../utilities/common";

function DriverTable(props) {
    const {t} = useTranslation('driverApproval');
    const dispatch = useDispatch();
    const {type, input, states} = props;
    const userPref = getUserPreference();

    const applicationInfo = useSelector(state => state.driverAppApproval.getIndividual);

    const [driverOpen, setDriverOpen] = useState(false);
    const [driverInfo, setDriverInfo] = useState({});
    const [driverList, setDriverList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pageTotal, setPageTotal] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));                
        setPage(0);
    }; 

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    function handleDriverOpen(driver) {
        setDriverOpen(true);
        setDriverInfo(driver);
    }
    function handleDriverClose() {
        setDriverOpen(false);
        props.handleUpdate();
        fetchData();
    }
    function fetchData() {
        if(input) {
            if(type === 1) {
                dispatch(getIndividual(30, page + 1, rowsPerPage, input, '', states, userPref.userCity));
                } else if(type === 2) {
                    dispatch(getIndividual(30, page + 1, rowsPerPage, '', input, states, userPref.userCity));
                } 
        } else {
            dispatch(getIndividual(30, page + 1, rowsPerPage, '', '', states, userPref.userCity));
        }
    }

    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage])
    useEffect(() => {
        if(applicationInfo.data) {
            setDriverList(applicationInfo.data);
            setPageTotal(applicationInfo.total);
        }
    }, [applicationInfo])
    useEffect(() => {
        setPage(0);
    }, [type, input, states])

    return (
        <div style={{height: 700}}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">{t('date')}</TableCell>
                            <TableCell align="center">{t('phone')}</TableCell>
                            <TableCell align="center">{t('last_name')}</TableCell>
                            <TableCell align="center">{t('first_name')}</TableCell>
                            <TableCell align="center">{t('_status')}</TableCell>
                            <TableCell align="center">{t('common:actions')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            driverList.length > 0 &&
                            driverList.map((driver) => (
                                <TableRow>
                                    <TableCell align="center">{driver.submit_time}</TableCell>
                                    <TableCell align="center">{driver.phone}</TableCell>
                                    <TableCell align="center">{driver.last_name}</TableCell>
                                    <TableCell align="center">{driver.first_name}</TableCell>
                                    <TableCell 
                                        align="center"
                                        style={
                                            driver.status === 1 ?
                                            {
                                                color: '#dd4b3f'
                                            } : (
                                                driver.status === 9 ?
                                                {
                                                    color: '#8a8b8a'
                                                } : (
                                                    driver.status === 8 ?
                                                    {
                                                        color: '#66bb6a'
                                                    } : {
                                                        color: '#ffffff'
                                                    }
                                                )
                                            )
                                        }
                                    >
                                        {driver._label_status}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button 
                                            color='primary' 
                                            variant="contained"
                                            onClick={()=> handleDriverOpen(driver)}
                                        >
                                            {t('review')}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                    <TableFooter>
                        <TableRow style={{align: "right"}}>
                            <TablePagination
                                rowsPerPageOptions={[10, 20, 200]}
                                colSpan={6}
                                count={pageTotal}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { 'aria-label': 'rows per page' },
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions} 
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <DriverRegistration  
                open={driverOpen} 
                driverOpenInfo={driverInfo}
                handleClose={handleDriverClose}
            />
        </div>
    )
}
export default DriverTable;